import contentcreatormenu from './content-creator-menu'
import customermenu from './customer-menu'
import defaultmenu from './default-menu'
import metricsmenu from './metrics-menu'
import rolesmenu from './roles-menu'
export default [
  ...contentcreatormenu.flat(),
  ...customermenu.flat(),
  ...defaultmenu.flat(),
  ...metricsmenu.flat(),
  ...rolesmenu.flat(),
]
